import { render, staticRenderFns } from "./TypeResidency.vue?vue&type=template&id=01db3b6f&scoped=true&"
import script from "./TypeResidency.ts?vue&type=script&lang=ts&"
export * from "./TypeResidency.ts?vue&type=script&lang=ts&"
import style0 from "./TypeResidency.vue?vue&type=style&index=0&id=01db3b6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01db3b6f",
  null
  
)

export default component.exports